export enum RoleEnum {
  OPERATOR = 'operator',
  ADMIN = 'admin',
  SUPERADMIN = 'superadmin',
  DEVELOPER = 'developer',
}
